import { RootState } from 'types/state'

export const MARK_PAYMENT_COMPLETE = 'MARK_PAYMENT_COMPLETE'
export const MARK_DIRECT_PAYMENT_CONFIRMED = 'MARK_DIRECT_PAYMENT_CONFIRMED'
export const UNDO_DIRECT_PAYMENT = 'UNDO_DIRECT_PAYMENT'
export const TRIGGER_DATA_REFRESH = 'TRIGGER_DATA_REFRESH'

export const markPaymentComplete = () => {
  return {
    type: MARK_PAYMENT_COMPLETE,
  }
}

export const triggerDataRefresh = () => {
  return {
    type: TRIGGER_DATA_REFRESH,
  }
}

export const markDirectPaymentConfirmed = () => {
  return {
    type: MARK_DIRECT_PAYMENT_CONFIRMED,
  }
}

export const undoDirectPayment = () => {
  return {
    type: MARK_DIRECT_PAYMENT_CONFIRMED,
  }
}

export type PaymentsPageState = {
  paymentIsComplete: boolean
  directPaymentIsConfirmed: boolean
  dataRefreshTrigger: null | string
}

const defaultState: PaymentsPageState = {
  paymentIsComplete: false,
  directPaymentIsConfirmed: false,
  dataRefreshTrigger: null,
}

export default function paymentsPageReducer(
  previousState: PaymentsPageState | undefined = defaultState,
  { type, payload }: { type: string; payload: any }
) {
  switch (type) {
    case MARK_PAYMENT_COMPLETE:
      // Clear all permissions caches when org switches
      return {
        ...previousState,
        paymentIsComplete: true,
      }
    case MARK_DIRECT_PAYMENT_CONFIRMED:
      return {
        ...previousState,
        directPaymentIsConfirmed: true,
      }
    case UNDO_DIRECT_PAYMENT:
      return {
        ...previousState,
        directPaymentIsConfirmed: false,
      }
    case TRIGGER_DATA_REFRESH:
      return {
        ...previousState,
        dataRefreshTrigger: `${new Date()}`,
      }
  }

  return previousState
}

export const paymentsPageSelectors = {
  getIsPaymentComplete: (state: RootState) => {
    return state.paymentsPage?.paymentIsComplete
  },
  getIsDirectPaymentConfirmed: (state: RootState) => {
    return state.paymentsPage?.directPaymentIsConfirmed
  },
  getDataRefreshTrigger: (state: RootState) => {
    return state.paymentsPage?.dataRefreshTrigger
  },
}
